import { render } from "./ObjectiveSorting.vue?vue&type=template&id=499a7cdc&scoped=true"
import script from "./ObjectiveSorting.vue?vue&type=script&lang=js"
export * from "./ObjectiveSorting.vue?vue&type=script&lang=js"

import "./ObjectiveSorting.vue?vue&type=style&index=0&id=499a7cdc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-499a7cdc"]])

export default __exports__